import useGetCidades from "core/features/estados/hooks/useGetCidades";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import { useState } from "react";

export interface SelectCidadeProps<T = any> extends SelectBaseAntdProps<T> {
  estadoId?: string | null;
}

function SelectCidade({ estadoId, ...rest }: SelectCidadeProps) {
  const [search, setSearch] = useState<string>();
  const { isLoading, data } = useGetCidades(estadoId);

  return (
    <SelectBaseAntd
      disabled={!estadoId || isLoading}
      loading={isLoading}
      size="large"
      placeholder="Cidade"
      allowClear
      showSearch
      searchValue={search}
      onSearch={setSearch}
      optionFilterProp="label"
      options={data?.map((item: any) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectCidade;
